import { t } from 'i18next';
import { DeliveryDTO } from '../../../api/generated';
import { extractDeliveryEntries } from '../../Delivery/deliveryConfig';

export async function downloadMultipleDeliveryCSV(
  deliveries: DeliveryDTO[],
  capturer_id: string,
  filename: string
): Promise<void> {
  try {
    if (deliveries.length === 0) {
      throw new Error('No deliveries provided');
    }
    const csvContent = generateDeliveryCSVs(deliveries, capturer_id);
    downloadCsvContent(csvContent, filename);
    return;
  } catch (error) {
    throw new Error(`Error generating CSV: ${error}`);
  }
}

function generateDeliveryCSVs(deliveries: DeliveryDTO[], capturer_id: string): string {
  if (deliveries.length === 0) {
    return '';
  }

  const allDeliveryEntries = deliveries.map((delivery) => extractDeliveryEntries(delivery, capturer_id));
  const headerRow = allDeliveryEntries[0]?.map(({ label }) => `"${t(label)}"`).join(',') || '';
  const dataRows = allDeliveryEntries.map((deliveryEntries) =>
    deliveryEntries.map(({ value }) => `"${String(value || '').replace(/"/g, '""')}"`).join(',')
  );

  return [headerRow, ...dataRows].join('\n');
}

function downloadCsvContent(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
}
